import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import {
    getDataQuery,
    getDetailsDataQuery,
    DetailsDataQueryT,
} from 'components/ChartContainer/components/RawDataModal/helpers/detailsDataQuery';
import { GetDataPayloadT } from 'business/definitions';
import { downloadFile } from 'helpers/helpers';
import { RQAPICall, HttpError } from 'store/APIClient';
import { transformQueryToDataQuery } from 'helpers/queryHelpers';

export const useDetailsDataQuery = (
    payload: DetailsDataQueryT,
): UseQueryResult<GetDataPayloadT['data'], HttpError> => {
    const { metric, point } = payload;
    const query = getDetailsDataQuery(payload);
    return useQuery({
        queryKey: [metric.field, JSON.stringify(point)],
        queryFn: async () => getDataQuery(query),
        enabled: point !== undefined,
    });
};

export const useExportDetailsDataQuery = (
    payload: DetailsDataQueryT,
    title: string,
    downloadFormat: 'xlsx' | 'csv' = 'xlsx',
) => {
    const { metric, point } = payload;
    return useMutation({
        mutationKey: [metric.field, JSON.stringify(point), downloadFormat],

        mutationFn: async () => {
            const query = getDetailsDataQuery(payload);
            return RQAPICall<Blob>({
                endpoint: 'query/get_data/v2/download',
                method: 'POST',
                body: {
                    ...transformQueryToDataQuery(query),
                    download_format: downloadFormat,
                },
            });
        },

        onSuccess: (response) => {
            const downloadURL = window.URL.createObjectURL(response.content);
            downloadFile(downloadURL, title, downloadFormat);
        },
    });
};
